// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b63ef082","860":"c8e7e48e"}[chunkId] + ".chunk.js";
};